export const getTitle = (isChildChangeAvailable) => {
    return isChildChangeAvailable ? 'Изменить номер Ребёнка' : 'Добавьте Ребёнка';
};
